import { TabSettingPageProps } from 'types/TabSettingPageProps';

export const tabsList: TabSettingPageProps[] = [
	{
		id: 0,
		name: 'settings.tabsSettings.general',
		isSelected: true
	},
	{
		id: 1,
		name: 'settings.tabsSettings.providers',
		isSelected: false
	},
	{
		id: 2,
		name: 'settings.tabsSettings.features',
		isSelected: false
	}
];
